import { Action, createFeatureSelector, createSelector } from '@ngrx/store';

import { Note } from 'mojo-irp-notes';
import { ModalActions } from '@shared/modal/modal.config';

import { ModalActionTypes, noteRejectedModalShow } from './modal.actions';
import { ModalButtonType } from './modal.component';

export interface ModalState {
  title: string;
  subTitle?: string;
  message: string;
  isCommentRequired?: boolean;
  canDecline?: boolean;
  confirmText?: string;
  cancelText?: string;
  isConfirmed?: boolean;
  isCancelled?: boolean;
  redirectUrl?: string;
  content?: string;
  buttonType?: ModalButtonType;
  notes?: Partial<Note>[];
  type: ModalActions;
}

export const initialState: ModalState = {
  title: '',
  message: '',
  isCommentRequired: false,
  confirmText: 'Yes',
  cancelText: 'No',
  isConfirmed: false,
  canDecline: true,
  content: '',
  type: ModalActions.CONFIRM_ACTION,
};

export const initialNoteModalState: ModalState = {
  ...initialState,
  confirmText: 'Save',
  cancelText: 'Cancel',
};

export function modalReducer(state = initialState, action: Action & { payload: any }): ModalState {
  switch (action.type) {
    case ModalActionTypes.Show:
      return {
        ...initialState,
        ...action.payload,
      };

    case ModalActionTypes.ShowNoteModal:
    case ModalActionTypes.ShowNoteDeclinedModal:
    // TODO(MOJAT-3794): remove noteRejectedModalShow as we don't use modal
    // store for displaying modal for this action
    // its only needed when MOJAT-3794 feature flag is off
    case noteRejectedModalShow.type:
      return {
        ...initialNoteModalState,
        ...action.payload,
      };
    case ModalActionTypes.Confirm:
      return {
        ...state,
        isConfirmed: true,
        redirectUrl: action.payload.redirectUrl,
        content: action.payload.content,
      };

    case ModalActionTypes.Cancel:
      return {
        ...initialState,
        isCancelled: true,
      };
    case ModalActionTypes.Reset:
      return {
        ...initialState,
      };
    default:
      return state;
  }
}

export const getModal = createFeatureSelector<ModalState>('modal');

export const getNotes = createSelector(getModal, (state: ModalState) => !!state && state.notes);

export const isModalConfirmed = createSelector(
  getModal,
  (state: ModalState) => !!state && state.isConfirmed,
);

export const isModalCancelled = createSelector(
  getModal,
  (state: ModalState) => !!state && state.isCancelled,
);

export const getModalRedirectUrl = createSelector(
  getModal,
  (state: ModalState) => !!state && state.redirectUrl,
);
